import { createApi } from 'unsplash-js'

const unsplash = createApi({
  accessKey: process.env.REACT_APP_UNSPLASH_ACCESSKEY as string,
})
export const getImages = async (params: any) => {
  const result = await unsplash.search.getPhotos(params)
  return result
}
